export const LOCALE_STORAGE_KEY = 'theme.locale';

export const AUTO_LOCALE = 'auto';

export const SUPPORTED_LOCALES = ['en', 'pt-br', 'es', 'it', 'fr', 'de', 'pl'];

export const detectLocaleFromNavigator = () => {
	if (typeof navigator === 'undefined') return null;

	for (const tag of (navigator.languages ?? [navigator.language ?? ''])) {
		const lower = String(tag).toLowerCase();

		if (lower.startsWith('pt')) return 'pt-br';
		if (lower.startsWith('es')) return 'es';
		if (lower.startsWith('it')) return 'it';
		if (lower.startsWith('fr')) return 'fr';
		if (lower.startsWith('de')) return 'de';
		if (lower.startsWith('pl')) return 'pl';
		if (lower.startsWith('en')) return 'en';
	}

	return null;
};

export const resolveLocale = (preference, fallback = 'en') => (
	preference === AUTO_LOCALE ? detectLocaleFromNavigator() ?? fallback : preference
);

export const readLocalePreference = () => {
	try {
		const stored = localStorage.getItem(LOCALE_STORAGE_KEY);

		return stored === AUTO_LOCALE || SUPPORTED_LOCALES.includes(stored) ? stored : AUTO_LOCALE;
	} catch {
		return AUTO_LOCALE;
	}
};

export const writeLocalePreference = locale => {
	try {
		localStorage.setItem(LOCALE_STORAGE_KEY, locale);
	} catch {
	}
};
